import CopyButton from './copy-button';

export const Clipboard = {
  CopyButton,
};
